import { classes } from '@theme/constants';
import { isFromBreakpoint } from '@theme/helpers';
import { HTMLCustomElement } from '@theme/html-custom-element';

// eslint-disable-next-line import/no-unresolved
import { MapboxSearchBox } from 'https://cdn.jsdelivr.net/npm/@mapbox/search-js-web@1.5.1/+esm';
// eslint-disable-next-line import/no-unresolved
import mapboxGl from 'https://cdn.jsdelivr.net/npm/mapbox-gl@3.18.0/+esm';

class StoreLocator extends HTMLCustomElement {
  accessToken = 'pk.eyJ1Ijoid2F0Y2hob3VzZSIsImEiOiJjazY5bGl5OTYwZWp6M2huOWp0MG15eG5vIn0.AXMxMSxK95BlMdDduOxV7w';

  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    mapboxGl.accessToken = this.accessToken;

    this.map = new mapboxGl.Map({
      container: this.refs.map,
      style: isFromBreakpoint('large')
        ? 'mapbox://styles/watchhouse/cmk5mha41001701r21lgw38l7'
        : 'mapbox://styles/watchhouse/cmm9p4vza001d01sg3av8c762',
      zoom: 12,
      pitch: isFromBreakpoint('large') ? 60 : 0,
      center: [-0.1276, 51.5072],
    });

    for (const store of this.stores) {
      if (store.longitude && store.latitude) {
        const markerElement = this.refs.marker.all.find(({ dataset }) => parseInt(dataset.locationId) === store.id);

        new mapboxGl.Marker(markerElement).setLngLat([store.longitude, store.latitude]).addTo(this.map);
      }
    }

    /**
     * Search.
     */
    const searchBox = new MapboxSearchBox();

    searchBox.accessToken = this.accessToken;

    searchBox.bindMap(this.map);

    this.refs.search.appendChild(searchBox);
    searchBox.input.classList = '';

    /**
     * Markers.
     */
    this.on('click', this.refs.marker.all, (event) => {
      for (const element of this.refs.overlay.all) {
        element.classList.toggle(classes.active, event.currentTarget.dataset.locationId === element.dataset.locationId);
      }

      for (const element of this.refs.marker.all) {
        element.classList.toggle(classes.active, event.currentTarget.dataset.locationId === element.dataset.locationId);
      }
    });

    this.on('click', this.refs.overlayClose.all, (event) => {
      const overlayElement = event.target.closest(`[data-ref="${this.refs.overlay.dataset.ref}"]`);

      if (overlayElement) {
        overlayElement.classList.remove(classes.active);

        for (const element of this.refs.marker.all) {
          if (element.dataset.locationId === overlayElement.dataset.locationId) {
            element.classList.remove(classes.active);
          }
        }
      }
    });
  }

  /**
   * @returns {array}
   */
  get stores() {
    return JSON.parse(this.refs.stores.innerHTML);
  }
}

if (!customElements.get('store-locator')) customElements.define('store-locator', StoreLocator);
